export default "__VITE_ASSET__17eaee0f__"